import { createSlice } from "@reduxjs/toolkit";
import { getCustomerConfig, updateCustomerConfig } from "../actions/customerConfigAction";

interface ICustomerConfigState {
    config: {
        id?: number;
        cronExpression: string;
        inactivityWindowDays: number;
        timeZone: string;
    } | null;
    loading: boolean;
    error: string | null;
    updateSuccess: boolean;
}

const initialState: ICustomerConfigState = {
    config: null,
    loading: false,
    error: null,
    updateSuccess: false,
};

const customerConfigSlice = createSlice({
    name: "customerConfig",
    initialState,
    reducers: {
        resetUpdateSuccess: (state) => {
            state.updateSuccess = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCustomerConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
            })
            .addCase(getCustomerConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updateCustomerConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.updateSuccess = false;
            })
            .addCase(updateCustomerConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
                state.updateSuccess = true;
            })
            .addCase(updateCustomerConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.updateSuccess = false;
            });
    },
});

export const customerConfigActions = customerConfigSlice.actions;
export default customerConfigSlice.reducer;
